import { Comment } from 'hooks/useCommentsRealtime'
import { ChatAttachedImage } from '../../../services/api/chatApi'

function displayName(comment: Comment): string {
  return comment.user_name || comment.user_email.split('@')[0]
}

export function composeFeedbackMessage(
  comment: Comment,
  replies: Comment[],
  coordinates: { x: number; y: number } | null,
): string {
  const lines: string[] = [
    'A team member left this feedback on the current image:',
    '',
    `"${comment.message}"`,
    `— ${displayName(comment)}`,
  ]

  if (replies.length > 0) {
    lines.push('', 'Thread replies:')
    for (const reply of replies) {
      lines.push(`- "${reply.message}" — ${displayName(reply)}`)
    }
  }

  if (coordinates) {
    lines.push(
      '',
      `The comment is pinned at position (${Math.round(coordinates.x * 100)}%, ${Math.round(coordinates.y * 100)}%) on the image.`,
    )
  }

  lines.push('', "How can I address this feedback using AI Conic's tools?")
  return lines.join('\n')
}

export async function urlToBase64(url: string): Promise<ChatAttachedImage | null> {
  try {
    const response = await fetch(url)
    if (!response.ok) return null

    const blob = await response.blob()
    const contentType = response.headers.get('content-type') || 'image/png'
    const mediaType = contentType.split(';')[0].trim() as ChatAttachedImage['media_type']

    return new Promise((resolve) => {
      const reader = new FileReader()
      reader.onload = () => {
        const dataUrl = reader.result as string
        const base64 = dataUrl.split(',')[1]
        resolve({ data: base64, media_type: mediaType })
      }
      reader.onerror = () => resolve(null)
      reader.readAsDataURL(blob)
    })
  } catch {
    return null
  }
}
